import Api from '@/api/vacancy.js';

const state = {
  loading: false,
  error: null,
  vacancies: [],
  sorting: {
    name: null,
    order: 'asc'
  },
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    totalCounts: 0,
    load_more_pages: 1,
    is_load_more: false,
    limit: 5
  }
};

const actions = {
  fetch({ commit, dispatch, state }, data) {
    commit('fetch');

    const sorting = state.sorting;

    let params = {
      filter: { title: data.searchTerm }
    };

    if (sorting.name) {
      params['sort_by'] = sorting.name;
      params['sort_order'] = sorting.order;
    }

    if (data && data.isActive !== undefined) {
      params.is_active = data.isActive;
    }

    let limit = state.pagination.limit;

    const is_load_more = state.pagination.is_load_more;

    if (is_load_more) {
      limit = state.pagination.pageNumber * state.vacancies.length + state.pagination.limit;

      params.page = 1;
      params.limit = limit;
    } else {
      params.page = state.pagination.pageNumber;
      params.limit = state.pagination.limit;
    }

    return Api.fetchList(params)
      .then(({ data, meta }) => {
        commit('fetchSuccess', { data, meta, is_load_more });

        if (is_load_more) {
          commit('set_pagination_more', { limit });
        }
      })
      .catch(err => {
        dispatch('global/setError', err, { root: true });
        commit('fetchFailure', err);
      });
  }
};

const mutations = {
  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, { data, meta, is_load_more }) {
    if (!is_load_more) {
      state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count);
    }

    state.pagination.totalCounts = meta.total;
    state.vacancies = data;
    state.loading = false;
  },

  fetchFailure(state, err) {
    state.error = err;
    state.loading = false;
    console.error(err);
  },

  updateSorting(state, data) {
    Object.assign(state.sorting, data);
  },

  updatePagination(state, params) {
    state.pagination = Object.assign(state.pagination, params);
  },

  set_load_more(state, val) {
    state.pagination = Object.assign(state.pagination, { is_load_more: val });
  },

  set_pagination_more(state, { count }) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count);
  },

  change_count(state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val,
      pageNumber: 1
    });
  },

  clear() {
    state.vacancies = [];

    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      totalCounts: 0,
      limit: 5,
      load_more_pages: 1,
      is_load_more: false
    });
  }
};

const getters = {
  error: state => {
    return state.error;
  },

  sorting: state => {
    return state.sorting;
  },

  pagination: state => {
    return state.pagination;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
